import React, { useState, useEffect } from "react"
import TableHolder from "../components/TableHolder"
import {
  Button,
  Modal,
  Table,
  Card,
  Input,
  Dimmer,
  Loader,
  Radio,
  Select,
  Dropdown,
  Menu,
} from "semantic-ui-react"
import { useTranslation } from "react-i18next"
import { apiGet, apiPost } from "../utils/apiConnector"
import {
  marksApi,
  emissionsApi,
  productListApi,
  productApi,
} from "../config/apiUrls"
import { useDispatch, useSelector } from "react-redux"
import { signOut } from "../ducks/profile"

const OrdersPage = (props) => {
  const [orderInner, setOrderInner] = useState([])
  const [orders, setOrders] = useState([])
  const [products, setProducts] = useState([])
  const [product, setProduct] = useState("")
  const [innerData, setInnerData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [innerLoading, setInnerLoading] = useState(false)
  const [adding, setAdding] = useState(false)
  const [modal, setModal] = useState(false)
  const [step, setStep] = useState(0)
  const [order, setOrder] = useState({ products: [] })
  const [barcode, setBarcode] = useState("")
  const [name, setName] = useState("")
  const [count, setCount] = useState("")
  const [cisType, setCisType] = useState("")
  const [serialType, setSerialType] = useState("")
  const [releaseMethodType, setReleaseMethodType] = useState("")
  const [createMethodType, setCreateMethodType] = useState("")
  const [templateId, setTemplateId] = useState("")
  const [temp, setTemp] = useState(0)
  const { profile } = useSelector((state) => ({ profile: state.profile }))
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const onSignOut = () => {
    dispatch(signOut())
  }
  const getOrders = () => {
    const ownerId = profile.id
    setIsLoading(true)
    apiGet(emissionsApi + "/" + ownerId, {})
      .onOk((res) => {
        console.log(res.data.response)
        setOrders(res.data.response)
      })
      .onFail((res) => {})
      .afterAll(() => {
        setIsLoading(false)
      })
      .startSingle()
  }
  const getInnerData = (id) => {
    setInnerLoading(true)
    apiGet(marksApi + "/" + id, {})
      .onOk((res) => {
        setOrderInner(orders.filter((q) => q.id === id))
        setInnerData(res.data.response)
      })
      .onFail(() => {})
      .afterAll(() => {
        setInnerLoading(false)
      })
      .startSingle()
  }
  const getProducts = () => {
    const storeId = profile.stores.length ? profile.stores[0].id : 0
    if (storeId) {
      apiGet(productListApi + "/" + storeId, {})
        .onOk((res) => {
          setProducts(res.data.response)
          if (res.data.response.length) {
            setProduct(res.data.response[0].id)
          }
        })
        .onFail(() => {})
        .afterAll(() => {})
        .startSingle()
    }
  }
  const config = {
    fname: t("Orders"),
    data: orders,
    headers: [
      { name: "gtin", title: "GTIN" },
      // { name: "id", title: "ID" },
      // { name: "orderId", title: "Order ID" },
      { name: "productName", title: "Product name" },
      { name: "qty", title: "Quantity" },
      { name: "status", title: "Status" },
      { name: "dt", title: "Date" },
      { name: "available", title: "Available" },
      // { name: "cisType", title: "Тип кода маркировки" },
      // { name: "SerialType", title: "Способ формирования серийного номера" },
    ],
    custom: "order",
    onClick: getInnerData,
    isLoading: () => isLoading,
    inner: {
      fname: t("Unused marks"),
      title: "Unused marks",
      isLoading: () => innerLoading,
      data: [innerData, orderInner],
      headers: [
        // { name: "markId", title: "ID" },
        { name: "code", title: "Product code" },
      ],
    },
  }
  const renderAddingProduct = () => {
    return (
      <>
        <Card fluid>
          <Card.Content>
            <div>
              <h3>{t("addingProduct")}</h3>
            </div>
            <div style={{ margin: 20 }}>
              <div>{t("Barcode")}</div>
              <div>
                <Input
                  value={barcode}
                  onChange={(e, d) => {
                    setBarcode(d.value)
                  }}
                  size="small"
                  style={{ marginTop: 10, marginBottom: 10 }}
                />
              </div>
              <div>{t("Product name")}</div>
              <div>
                <Input
                  value={name}
                  onChange={(e, d) => {
                    setName(d.value)
                  }}
                  size="small"
                  style={{ marginTop: 10, marginBottom: 10 }}
                />
              </div>
              <div>
                <Button
                  content={t("Save")}
                  positive
                  style={{ marginTop: 30 }}
                  onClick={() => {
                    const storeId = profile.stores.length
                      ? profile.stores[0].id
                      : 0
                    if (storeId) {
                      const req = {}
                      req.barcode = barcode
                      req.name = name
                      req.storeId = storeId
                      apiPost(productApi, req)
                        .onOk((res) => {
                          console.log(res.data.response)
                        })
                        .onFail(() => {})
                        .afterAll(() => {
                          getProducts()
                          setAdding(false)
                          setName("")
                          setBarcode("")
                          setModal(false)
                        })
                        .startSingle()
                    }
                    setName("")
                    setBarcode("")
                    setModal(false)
                  }}
                />
              </div>
            </div>
          </Card.Content>
        </Card>
      </>
    )
  }
  const renderNew = () => {
    return (
      <>
        <div>
          {" "}
          <Card fluid>
            <Card.Content>
              <h3>{t("New order")}</h3>
              <div
                style={{
                  marginTop: 10,
                }}
              >
                <div>
                  <Select
                    options={products.map((q) => {
                      return {
                        key: q.id,
                        value: q.id,
                        text: q.name,
                      }
                    })}
                    placeholder={t("Product")}
                    styles={{
                      // Fixes the overlapping problem of the component
                      menu: (provided) => ({
                        ...provided,
                        position: "relative",
                        zIndex: 9999,
                        overflowY: "scroll",
                      }),
                    }}
                    style={{
                      position: "relative",
                      zIndex: 9999,
                    }}
                    onChange={(e, d) => {
                      setProduct(d.value)
                    }}
                  />
                </div>
                <div style={{ display: "none" }}>
                  <Select
                    placeholder={"Тип кода маркировки"}
                    options={[
                      { key: 0, value: "GROUP", text: t("GROUP") },
                      { key: 1, value: "UNIT", text: t("UNIT") },
                    ]}
                    style={{ marginTop: 10 }}
                    value={cisType}
                    onChange={(e, d) => {
                      setCisType(d.value)
                    }}
                  />
                </div>
                <div>
                  <Select
                    placeholder={t("Method of forming serial goods")}
                    options={[
                      { key: 0, value: "OPERATOR", text: t("OPERATOR") },
                      { key: 1, value: "SELF_MADE", text: t("SELF_MADE") },
                    ]}
                    style={{ marginTop: 10 }}
                    value={serialType}
                    onChange={(e, d) => {
                      setSerialType(d.value)
                    }}
                  />
                </div>
                <div style={{ marginTop: 10 }}>
                  <Input
                    type="number"
                    value={count}
                    placeholder={t("Quantity")}
                    onChange={(e, d) => {
                      setCount(d.value)
                    }}
                    style={{ marginTop: 10 }}
                  />
                </div>
                <div>
                  <Select
                    placeholder={t(
                      "Method of release of goods into circulation",
                    )}
                    options={[
                      { key: 0, value: "PRODUCTION", text: t("PRODUCTION") },
                      { key: 1, value: "IMPORT", text: t("IMPORT") },
                      { key: 1, value: "REMAINS", text: t("REMAINS") },
                      { key: 1, value: "CROSSBORDER ", text: t("CROSSBORDER") },
                    ]}
                    style={{ marginTop: 10 }}
                    value={releaseMethodType}
                    onChange={(e, d) => {
                      setReleaseMethodType(d.value)
                    }}
                  />
                </div>
                <div>
                  <Select
                    placeholder={t("Preparation method")}
                    options={[
                      { key: 1, value: "SELF_MADE", text: t("SELF_MADE") },
                    ]}
                    style={{ marginTop: 10 }}
                    value={createMethodType}
                    onChange={(e, d) => {
                      setCreateMethodType(d.value)
                    }}
                  />
                </div>
                <div>
                  <Select
                    placeholder={t("Product type")}
                    options={[
                      { key: 1, value: 13, text: t("Alcohol (unit)") },
                      {
                        key: 2,
                        value: 17,
                        text: t("Alcohol (group packaging)"),
                      },
                      { key: 3, value: 2, text: t("Medicines") },
                      { key: 4, value: 3, text: t("Cigarettes (block)") },
                      { key: 5, value: 4, text: t("Cigarettes (package)") },
                      { key: 6, value: 1, text: t("Shoes") },
                    ]}
                    style={{ marginTop: 10 }}
                    value={templateId}
                    onChange={(e, d) => {
                      setTemplateId(d.value)
                    }}
                  />
                </div>
              </div>
              <div
                style={{
                  marginTop: 70,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Button
                  positive
                  content={"Add product"}
                  style={{ float: "right" }}
                  onClick={() => {
                    setAdding(true)
                  }}
                />
                <Button
                  positive
                  content={t("Make an order")}
                  style={{ float: "right" }}
                  onClick={() => {
                    const req = {}
                    products.map((q) => {
                      if (product === q.id) {
                        req.gtin = q.barcode + ""
                      }
                    })
                    if (cisType) {
                      req.cisType = cisType
                    }
                    if (serialType) {
                      req.serialType = serialType
                    }
                    if (releaseMethodType) {
                      req.releaseMethodType = releaseMethodType
                    }
                    if (createMethodType) {
                      req.createMethodType = createMethodType
                    }
                    if (templateId) {
                      req.templateId = templateId
                    }
                    req.qty = parseInt(count)
                    const ownerId = profile.id
                    console.log(req)
                    if (req.qty && req.gtin) {
                      apiPost(emissionsApi + "/" + ownerId, req)
                        .onOk((res) => {
                          console.log(res)
                          getOrders()
                          getProducts()
                        })
                        .onFail(() => {})
                        .afterAll(() => {})
                        .startSingle()
                    }
                    setModal(false)
                    setProduct("")
                    setCount("")
                    setCisType("")
                    setSerialType("")
                    setReleaseMethodType("")
                    setCreateMethodType("")
                    setTemplateId("")
                  }}
                  disabled={
                    !product ||
                    !count ||
                    // !cisType ||
                    !serialType ||
                    !releaseMethodType ||
                    !createMethodType ||
                    !templateId
                  }
                />
              </div>
            </Card.Content>
          </Card>
        </div>
      </>
    )
  }
  const renderModal = () => {
    return (
      <>
        <Modal
          open={modal}
          onClose={() => {
            setModal(false)
            setOrder({ products: [] })
            setStep(0)
            setAdding(false)
            setProduct("")
            setCount("")
            setCisType("")
            setSerialType("")
            setTemplateId("")
          }}
          style={{ marginTop: "-40vh", height: "max-content" }}
        >
          {adding ? renderAddingProduct() : renderNew()}
        </Modal>
      </>
    )
  }
  useEffect(() => {
    getOrders()
    getProducts()
    return () => {}
  }, [])
  return (
    <>
      <div>
        <h2>{t("OrdersPage")}</h2>
        <Button
          content={t("New order")}
          positive
          style={{ marginTop: 10, marginBottom: 10 }}
          onClick={() => {
            setModal(true)
          }}
        />
        <TableHolder config={config} />
        {renderModal()}
      </div>
    </>
  )
}

export default OrdersPage
